/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, DisplayText, TextStyle, Button } from '@shopify/polaris';
import welcomeImage from 'src/assets/images/dashboard/welcome.png';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  name: string,
  welcome: Object
};

class Welcome extends Component<Props> {
  render() {
    const { name, welcome } = this.props;
    const { contents = {} } = welcome;

    const {
      title = 'Welcome',
      description = 'Please set up Filter Tree now to use our app',
      buttonLabel = 'Manage Filter Trees',
      buttonCTALink = routes.filterTree.list()
    } = contents;

    return (
      <div className="BC-Welcome__Dashboard">
        <Layout>
          <Layout.Section>
            <DisplayText size="large">
              {title}, {name}!
            </DisplayText>
            <DisplayText size="small">
              <TextStyle variation="subdued">{description}</TextStyle>
            </DisplayText>
            <Button
              primary
              onClick={() => {
                if (buttonCTALink.startsWith('/')) {
                  history.push(buttonCTALink);
                } else {
                  window.open(buttonCTALink, '_blank');
                }
              }}>
              {buttonLabel}
            </Button>
          </Layout.Section>
          <Layout.Section oneThird>
            <img
              className="BC-Illustration-Image__Dashboard BC-Welcome__Image"
              src={welcomeImage}
              alt="Wellcome"
            />
          </Layout.Section>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const externalInfo = _.get(state.oauth.tenantApp, 'externalInfo', {});
  const welcome = _.get(state.dashboard, 'dashboardComponents.welcomes.data', {});

  return {
    name: _.get(externalInfo, 'name', ''),
    welcome
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
